
import React from 'react';
import { Card } from "@/components/ui/card";
import { BookingLink } from '@/types/booking';
import { Clock, DollarSign, AlertCircle } from 'lucide-react';

interface ServiceDetailsPanelProps {
  serviceDetails?: BookingLink['serviceDetails'];
  duration: number;
}

const ServiceDetailsPanel: React.FC<ServiceDetailsPanelProps> = ({ 
  serviceDetails,
  duration
}) => {
  if (!serviceDetails?.name && !serviceDetails?.price) return null;

  return (
    <Card className="p-6 mb-6">
      <h3 className="text-lg font-medium mb-4">Service Details</h3>
      
      <div className="space-y-4">
        {serviceDetails?.name && (
          <div>
            <h4 className="text-sm font-medium">Service</h4>
            <p className="text-foreground">{serviceDetails.name}</p>
            {serviceDetails.description && (
              <p className="text-sm text-muted-foreground mt-1">
                {serviceDetails.description}
              </p>
            )}
          </div>
        )}
        
        <div className="flex items-center">
          <Clock className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-sm">{duration} minutes</span>
        </div>
        
        {serviceDetails?.price > 0 && (
          <div className="flex items-center">
            <DollarSign className="h-4 w-4 mr-2 text-muted-foreground" />
            <span className="text-sm">${serviceDetails.price.toFixed(2)}</span>
          </div>
        )}
        
        {serviceDetails?.cancellationPolicy && (
          <div className="pt-4 border-t border-border">
            <div className="flex items-start">
              <AlertCircle className="h-4 w-4 mr-2 text-muted-foreground mt-0.5" />
              <div>
                <h4 className="text-sm font-medium">Cancellation Policy</h4>
                <p className="text-xs text-muted-foreground mt-1">
                  {serviceDetails.cancellationPolicy}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default ServiceDetailsPanel;
